import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = (props) => {
  const { menuItem } = props;
  const navigate = useNavigate();

  return (
    <nav id="main-menu" className="ml-auto">
      <ul>
        {/* <li className="menu-item-has-children">
          <a href="#home">Home</a>
          <ul className="sub-menu">
            <li>
              <Link to={"/react-templates/raino"}>Home One</Link>
            </li>
            <li>
              <Link to={"/react-remplates/raino/home-two"}>Home Two</Link>
            </li>
          </ul>
        </li>
        <li>
          <a href="#features">Features</a>
        </li>
        <li>
          <a href="#service">Service</a>
        </li>
        <li className="menu-item-has-children">
          <a href="#portfolio">Portfolio</a>
          <ul className="sub-menu">
            <li>
              <Link to={"/react-remplates/raino/portfolio-details"}>
                Portfolio Details
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <a href="#team">Team</a>
        </li>
        <li>
          <a href="#pricing">Pricing</a>
        </li>
        <li>
          <a href="#blog">Blog</a>
        </li>
        <li>
          <a className="block-menu" href="#contact">
            Contact us
          </a>
        </li> */}

        {menuItem.map((item, index) => (
          <li key={index}>
            <a
              href={`#${item}`}
              onClick={() => navigate("/")}
            >
              {item}
            </a>
            {item === "home" && (
              <ul className="sub-menu">
                <li>
                  <Link to={"/"}>Home One</Link>
                </li>
                <li>
                  <Link to={"/home-two"}>Home Two</Link>
                </li>
              </ul>
            )}
            {item === "portfolio" && (
              <ul className="sub-menu">
                <li>
                  <Link to={"/portfolio-details"}>
                    Portfolio Details
                  </Link>
                </li>
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
